import {Box, LinearProgress} from "@mui/material";
import './styles/task.scss'
import {
    ConversionType,
    ExtraProps,
    ResponseProp,
    TaskStatusType
} from "../../types/taskFlow.types";
import { useTranslation } from 'react-i18next'


interface PromptProps {
    loading?: boolean,
    taskResponse?: ResponseProp,
    content?: string
    status?: TaskStatusType,
    taskId?: number,
    extra?: ExtraProps,
    conversionValue: ConversionType
}

export default function Prompt (props: PromptProps) {
    const { t } = useTranslation()
    const {loading, taskResponse, content, conversionValue, extra} = props;
    const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''
    return <Box className="task_manage_box">
        { (taskResponse && 'note' in taskResponse) ? taskResponse.note : content }
        { conversionValue === ConversionType.HISTORY && <Box className="task_manage_sub">
            {
                extra?.images?.length ? <img style={{width: '100%'}} src={temporary_url+extra?.images[0]} alt=''/> :  <span>{t('parsing_dialog')}</span>
            }</Box>}
        {conversionValue === ConversionType.CONVERSING && <LinearProgress style={{marginTop: 6}} /> }
    </Box>
}